import { Box, Grid, IconButton, Toolbar, useMediaQuery, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import logo from '../../src/assets/img/logo_espolads.png';
import { InstitucionalPalette, themePalette } from "../config/theme.config";
import { FaUserCircle } from "react-icons/fa";
import { redirectToCasLogin } from "../cas/casUtils";
import { useAppSelector } from "../redux/hooks";
import AvatarMenu from "./User/AvatarMenu";
import { SignInButton } from "../helpers/EntraID/SignInButton";
import { Iconify } from "./iconify";

const casConfig = {
    casServer: process.env.REACT_APP_CAS!,
    service: process.env.REACT_APP_FRONT!,
};

export const HeaderBar: React.FC<{ isTest?: boolean }> = ({ isTest = false }) => {
    const { isAuth, userData } = useAppSelector((state) => state.authReducer)
    const theme = useTheme();
    const isXSmallScreen = useMediaQuery(theme.breakpoints.down('xs'));
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    //#region variables
    const navigate = useNavigate();
    //#endregion
    //#region function
    const goToNavigation = (site: string) => {
        navigate(site)
    }
    const handleLogin = () => {
        redirectToCasLogin(casConfig.casServer, casConfig.service);
    };
    const imgSizes = () => {
        if (isXSmallScreen) {
            return 150;
        } else if (isSmallScreen) {
            return 150;
        } else {
            return 300;
        }
    };
    //#endregion
    const w = imgSizes();
    return (
        <Box sx={{ flexGrow: 1, backgroundColor: themePalette.BGWHITE }} >
            {/* <AppBar sx={{backgroundColor: themePalette.NAVCOLOR}} style={{minHeight:'10vh'}}> */}
            <Toolbar>
                <Grid container
                    direction={'row'}
                    justifyContent={'space-between'}
                    alignItems={'center'}
                >
                    <Grid item xs={6} sm md lg xl>
                        <Box sx={{ m: 1, ml: 10 }} >
                            <img src={logo} style={{ width: w, height: 'auto' }} />
                        </Box>
                    </Grid>
                    <Grid item>
                        {isTest ?
                            <IconButton onClick={() => {window.location.href = "/General";}}>
                                <Iconify icon='streamline:login-1-solid' width={40} color={InstitucionalPalette.PRIMARY} />
                            </IconButton>
                            :
                            <SignInButton color={InstitucionalPalette.PRIMARY} />
                        }
                    </Grid>
                </Grid>
            </Toolbar>
            {/* </AppBar> */}
        </Box>
    );
}